import NumberFormat from "%/dynamic-component-editor/options/number-format";
import { formatNumber } from "%/dynamic-components/render-engine/helpers/number-format";

export const NumberElementMixin = {
  options: [NumberFormat],
  data() {
    return {
      NumberFormat,
    };
  },
  methods: {
    formattedNumber(value) {
      return formatNumber(value, this.getOptionValue(NumberFormat));
    },
  },
};
